export const getEditableAttrs = (obj: any) => {
  if (!obj || typeof obj !== 'object') return {};

  return Object.keys(obj)
    .filter(key => key.startsWith('data-blok'))
    .reduce((attrs, key) => ({ ...attrs, [key]: obj[key] }), {});
};

const SIZES_VERTICAL =
  "(max-width: 833px) 320px, (max-width: 1023px) 420px, 290px";
const SIZES_HORIZONTAL =
  "(max-width: 833px) 480px, (max-width: 1023px) 630px, 435px";

export function getImageSizes(src: string | undefined): string {
  if (!src) return SIZES_VERTICAL;

  const match = src.match(/\/(\d+)x(\d+)\//);
  if (match && match[1] && match[2]) {
    const width = parseInt(match[1], 10);
    const height = parseInt(match[2], 10);
    if (width > height) {
      return SIZES_HORIZONTAL;
    }
  }
  return SIZES_VERTICAL;
}

export { SIZES_VERTICAL, SIZES_HORIZONTAL };